import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import { articles } from "@/mocks/articles";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...articles.map((a) => ({
    path: `/${a.slug}`,
    element: <ArticlePage slug={a.slug} />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;